import { render, staticRenderFns } from "./wxkf-editor.vue?vue&type=template&id=536d35ac"
import script from "./wxkf-editor.vue?vue&type=script&lang=js"
export * from "./wxkf-editor.vue?vue&type=script&lang=js"
import style0 from "./wxkf-editor.vue?vue&type=style&index=0&id=536d35ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports